import { create } from 'zustand';
import type { User } from 'firebase/auth';
import type { BaseUser } from '@/types/user.types';

interface AuthState {
  user: User | null;
  userData: BaseUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  setUser: (user: User | null, userData: BaseUser | null) => void;
  setLoading: (loading: boolean) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  userData: null,
  isAuthenticated: false,
  isLoading: true,
  setUser: (user, userData) =>
    set({ user, userData, isAuthenticated: !!user, isLoading: false }),
  setLoading: loading => set({ isLoading: loading }),
  clearUser: () =>
    set({ user: null, userData: null, isAuthenticated: false, isLoading: false }),
}));
